var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightGreenGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1414,
    height: 972,
    viewBox: "0 0 1414 972",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_257_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.032 727.5L1170.03 618.063L244.032 244L588.032 727.5Z",
    fill: "#55F494"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_257_16",
    x: 0.201675,
    y: 0.169998,
    width: 1413.66,
    height: 971.16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 121.915,
    result: "effect1_foregroundBlur_257_16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightGreenGlow);
export default __webpack_public_path__ + "static/media/lightGreenGlow.e48449c81e49bf6ed07a1bb4174b7efc.svg";
export { ForwardRef as ReactComponent };